import {
    SET_AUTH_TOKENS,
    SET_AUTH_REFRESH_TOKEN,
    SIGNOUT_AUTH_SUCCESS,
    UPDATE_AUTH_USER,
    SET_AUTH_FAILED_MSG
  } from './../../constants/ActionTypes';
  
  export type ActionType = {
    type: string;
    payload: any;
  }

  type initialStateType = {
    user: any;
    token: string | null;
    refreshToken: string | null;
    errorMsg: string | null;
  }

  const INIT_STATE: initialStateType = {
    user: null,
    token: null,
    refreshToken: null,
    errorMsg: null
  };
  
  const authReducer = (state = INIT_STATE, action: ActionType) => {
    switch (action.type) {
      case UPDATE_AUTH_USER: {
        return {
          ...state,
          user: action.payload,
        };
      }
      case SIGNOUT_AUTH_SUCCESS: {
        return {
          ...state,
          user: null,
          token: null,
          refreshToken: null
        };
      }
      case SET_AUTH_TOKENS: {
        return {
          ...state,
          token: action.payload.access,
          refreshToken: action.payload.refresh
        };
      }
      case SET_AUTH_REFRESH_TOKEN: {
        return {
          ...state,
          refreshToken: action.payload
        };
      }
      case SET_AUTH_FAILED_MSG:
        return {
          ...state,
          errorMsg: action.payload
        }
      default:
        return state;
    }
  };
  export default authReducer;
  